import { lazy } from 'react';

const SupplementalPlanRequirementListDrawer = lazy(
  () =>
    import(
      'modules/CoursePlanner/pages/Summary/components/SupplementalPlanRequirementListDrawer'
    ),
);

const OptimizationModal = lazy(
  () => import('modules/CoursePlanner/modals/OptimizationModal'),
);

export default {
  SUPPLEMENTAL_PLAN_REQUIREMENT_LIST_DRAWER:
    SupplementalPlanRequirementListDrawer,
  OPTIMIZATION_MODAL: OptimizationModal,
};
